import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/scroll-progress/scroll-progress.component.js'

const tagName = 'dap-ds-scroll-progress'

/**
 * `dap-ds-scroll-progress`
 * @summary A progress bar that displays scroll position, supporting both page-level and container-level scroll tracking.
 * @element dap-ds-scroll-progress
 * @title - Scroll Progress
 *
 * @csspart base - The main scroll progress container.
 * @csspart track - The progress track (background).
 * @csspart fill - The progress fill bar.
 *
 * @cssprop --dds-scroll-progress-z-index - Z-index for fixed positioning (default: 1000)
 * @cssprop --dds-scroll-progress-transition - Transition for progress updates (default: width 0.1s ease-out)
 * @cssprop --dds-scroll-progress-track-color - Background color of the progress track (default: var(--dds-neutral-200))
 * @cssprop --dds-scroll-progress-fill-color-neutral - Fill color for neutral variant
 * @cssprop --dds-scroll-progress-fill-color-brand - Fill color for brand variant
 * @cssprop --dds-scroll-progress-fill-color-negative - Fill color for negative variant
 * @cssprop --dds-scroll-progress-fill-color-positive - Fill color for positive variant
 * @cssprop --dds-scroll-progress-fill-color-inverted - Fill color for inverted variant
 *
 * @property { 'xxs' | 'xs' | 'sm' | 'md' | 'lg' } size - The size of the scroll progress bar. Default is `sm`. See SizedMixin.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg"); see SizedMixin.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSScrollProgress',
})

export default reactWrapper
